import { AffirmIcon } from '@c/icons';
import { shouldShowAffirmMessaging } from '@util/affirm/eligibility';

interface AffirmTagProps {
  amountUSD: number;
  className?: string;
}

/**
 * Static, eligibility-gated "Monthly payments available" tag — no dollar
 * figure. Used on grid cards (mounting a Stripe iframe per card is a
 * performance non-starter) and as the fallback for <AffirmMessaging>
 * when the Stripe element itself can't load (blocked script, outage).
 * Never invents a $/mo number — that's the whole point of GB #1372's
 * formula deletion.
 */
export function AffirmTag({ amountUSD, className }: AffirmTagProps) {
  if (!shouldShowAffirmMessaging(amountUSD)) return null;

  return (
    <span
      className={`inline-flex items-center gap-[0.5rem] text-[1.1rem] text-gray-700 ${className ?? ''}`}
    >
      <AffirmIcon w={30} h={18} />
      <span>Monthly payments available.</span>
    </span>
  );
}
